<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cấu hình website</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="16">
          <el-form label-position="right" :model="modelData" ref="createModel">
            <el-tabs v-model="activeName">
              <el-tab-pane label="Thông tin chung" name="first">
                <el-form-item prop="name_company" label="Tên công ty" class="form-item">
                  <el-input v-model="modelData.name_company" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="solugan" label="Solugan" class="form-item">
                  <el-input v-model="modelData.solugan" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="address" label="Địa chỉ" class="form-item">
                  <el-input v-model="modelData.address" class="input-seach"></el-input>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane label="Liên hệ" name="second">
                <el-form-item prop="tel" label="Tel" class="form-item">
                  <el-input v-model="modelData.tel" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item prop="hotline" label="Hotline" class="form-item">
                  <el-input v-model="modelData.hotline" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="time_open" label="Thời gian mở cửa" class="form-item">
                  <el-input v-model="modelData.time_open" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="email_1" label="Email" class="form-item"
                  :rules="[
                    { type: 'email', message: 'Email không đúng định dạng' }
                  ]">
                  <el-input v-model="modelData.email_1" class="input-seach"></el-input>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane label="Mạng xã hội" name="third">
                <el-form-item prop="facebook" label="Kết nối Facebook" class="form-item">
                  <el-input v-model="modelData.facebook" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="twitter" label="Kết nối Twitter" class="form-item">
                  <el-input v-model="modelData.twitter" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="skype" label="Kết nối Skype" class="form-item">
                  <el-input v-model="modelData.skype" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="youtube" label="Kết nối Youtube" class="form-item">
                  <el-input v-model="modelData.youtube" class="input-seach"></el-input>
                </el-form-item>

                <h4>Kết nối Zalo</h4>
                <div v-for="(image_p) in modelData.zalo_link" :key="image_p.key">
                  <div class="in-line">
                    <el-input v-model="image_p.link" class="input-seach"></el-input>
                    <el-button @click.prevent="removeZaloLink(image_p)" size="small">Xóa</el-button>
                  </div>
                </div>
                <el-button class="huhu" type="default" size="mini" @click="addZaloLink()">Thêm link</el-button>

                <el-form-item prop="zalo" label="Kết nối Zalo Hotline" class="form-item">
                  <el-input v-model="modelData.zalo" class="input-seach"></el-input>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane label="Cấu hình SEO Website" name="five">
                <el-form-item prop="meta_title" label="Thẻ Meta Title" class="form-item">
                  <el-input v-model="modelData.meta_title" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="meta_keyword" label="Thẻ Meta Keyword" class="form-item">
                  <el-input v-model="modelData.meta_keyword" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="meta_description" label="Thẻ Meta Description" class="form-item">
                  <el-input v-model="modelData.meta_description" class="input-seach"></el-input>
                </el-form-item>
              </el-tab-pane>
             </el-tabs>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitForm('createModel')">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'SettingUpdate',
  metaInfo () {
    return {
      title: 'Cấu hình'
    }
  },
  data () {
    return {
      canSubmit: true,
      activeName: 'first',
      modelData: {
        logo: '',
        name_company: '',
        solugan: '',
        address: '',
        email_1: '',
        email_2: '',
        email_3: '',
        phone_1: '',
        phone_2: '',
        phone_3: '',
        skype_1: '',
        skype_2: '',
        skype_3: '',
        yahoo_1: '',
        yahoo_2: '',
        yahoo_3: '',
        meta_title: '',
        meta_keyword: '',
        meta_description: '',
        meta_short_description: '',
        meta_js_codes: '',
        facebook: '',
        googleplus: '',
        youtube: '',
        twitter: '',
        linkin: '',
        ratio_vnd_kha: 0
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'settings-update', text: 'Cấu hình hệ thống' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'home-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.post('settings/get-setting').then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      axios.put('settings/' + this.modelData.id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật cấu hình hệ thống thành công',
              type: 'success'
            })
            // this.$router.push({name: 'settings-index'})
            this.$router.push({name: 'settings-update', params: {id: this.$route.params.id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    addZaloLink () {
      this.modelData.zalo_link.push({
        'key': Math.floor(Math.random() * 100000) + 1,
        'link': ''
      })
    },
    removeZaloLink (item) {
      var index = this.modelData.zalo_link.indexOf(item)
      if (index !== -1) {
        this.modelData.zalo_link.splice(index, 1)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.in-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}

.in-line input {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/Update.vue